export default "__VITE_ASSET__BiHg8L7s__"